export default __webpack_public_path__ + "static/media/0.ddc85a16.png";